<template>
  <div>
    <tci-title :title="title" :subtitle="subtitle" color="white">
      <v-row :class='index%2==0?"grey lighten-2 pb-0":" pb-0"' v-for="(recruit,index) in recruits" :key="recruit.name">
        <tci-recruit-card :title="title" :name="recruit.name" :position="recruit.position"  
        :email="recruit.email" :responses="recruit.responses" :requests="recruit.requests" 
        :practice="recruit.practice" :allTitle="allTitle"></tci-recruit-card>
      </v-row>
    </tci-title>
    <tci-contact-footer color="grey lighten-2"></tci-contact-footer>
  </div>
</template>

<script>
import TciTitle from "./TciTitle.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciRecruitCard from "@/components/TciRecruitCard.vue";

export default {
  name: "TciRecruit",
  props: {
    title: String,
    subtitle: String,
    content: String,
    recruits: Array,
    allTitle: Boolean
  },
  components: {
    "tci-title": TciTitle,
    "tci-contact-footer": TciContactFooter,
    "tci-recruit-card": TciRecruitCard
  }
};
</script>
